import React from "react"

type ModalProps = {
  screen?: boolean
  align?: 'center' | 'right' | 'left'
  width?: 'md'
  header?: JSX.Element
  body?: JSX.Element
  footer?: JSX.Element
  rounded?: boolean
  maxWidth?: 'md' | 'lg' | '2xl' | '6xl'
  bodyStyle?: string
  fullHeight?: boolean
  pin?: boolean
  classes?: string
}

class Modal extends React.Component<ModalProps> {
  render() {
    const {screen, align, width, header, body, footer, rounded, maxWidth, bodyStyle, fullHeight, pin, classes} = this.props
    return (
      <div className="modal-mask">
        <div className={"relative w-full h-full table " +
        (!align || align === 'center' ? ' flex justify-center items-center' : '')
        }>
          <div className={"absolute left-0 right-0 flex flex-col bg-white max-h-screen m-2" +
          (screen ? ' w-full h-full' : '') +
          (fullHeight ? ' h-full ' : '') +
          (pin ? ' top-0 bottom-0 ' : '') +
          (!screen && !maxWidth ? ' max-w-2xl' : '') +
          (maxWidth === '6xl' ? ' max-w-6xl' : '') +
          (maxWidth === '2xl' ? ' max-w-2xl' : '') +
          (maxWidth === 'lg' ? ' max-w-lg' : '') +
          (!align || align === 'center' ? ' sm:mx-auto' : '') +
          (align === 'right' ? ' md:ml-auto md:right-0' : '') +
          (width === 'md' ? ' max-w-md' : '') +
          (rounded ? ' md:rounded' : '') +
          (classes || '')
          }>
            {
              header ?
                <div className="modal-header border-none bg-gray-200">
                  {header}
                </div>
                : null
            }

            {
              body ?
                <div className={"modal-body h-full " + (bodyStyle || '')}>
                  {body}
                </div>
                : null
            }

            {
              footer ?
                <div className="modal-footer">
                  {footer}
                </div>
                : null
            }
          </div>
        </div>
      </div>
    )
  }
}

export default Modal
